import windowOrGlobal from '@atlas/tool/box/browser/windowOrGlobal';

windowOrGlobal._atlas = windowOrGlobal._atlas || {};
const shared = windowOrGlobal._atlas;

export default shared;

// #region Types

declare global {
    interface Window {
        // Parameters exposed by backend
        _atlas: {
            csrfToken?: string;
            tabId?: string;
            CONSTANTS?: {
                AUTH0_DOMAIN?: string;
                AUTH0_API_AUDIENCE?: string;
                AUTH0_SPA_CLIENT_ID?: string;
                WS_PROTOCOL?: string;
                ENV?: string;
                DEMO_ACCOUNTS?: string;
                SENTRY_DSN?: string;
                STRIPE_PAYMENT_LINK?: string;
                ANALYTIC_PROVIDERS?: {
                    POSTHOG?: {
                        ENDPOINT: string;
                        KEY: string;
                    };
                    NOOP: Record<string, unknown>;
                };
                ENABLED_ANALYTIC_PROVIDERS?: string[];
                SHOPIFY_INSTALLATION_URL?: string;
            };
        };
    }

    var _atlas: Window['_atlas'];
}

// #endregion

// #region Tests

if (import.meta.vitest) {
    const { describe, test, expect } = import.meta.vitest;
    describe('shared', () => {
        test('it is an object', () => {
            expect(shared).toBeInstanceOf(Object);
        });
    });
}

// #endregion
